import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const Authenticate = (usernameOrEmail, password, rememberMe = false, tenantId = null) => {
  const url = apiConstants.Authenticate;

  // Get tenantId from query string if not provided as parameter
  let finalTenantId = tenantId;
  if (!finalTenantId) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const queryTenantId = urlParams.get('tenantId');
      if (queryTenantId) {
        finalTenantId = parseInt(queryTenantId, 10);
      }
    } catch (e) {
      // If URL parsing fails, continue with default
    }
  }

  // Default to 3 if no tenantId found in query string or parameter
  if (!finalTenantId || isNaN(finalTenantId)) {
    // Try to load from localStorage first
    try {
      const storedTenantId = localStorage.getItem('tenantId');
      if (storedTenantId) {
        finalTenantId = parseInt(storedTenantId, 10);
      }
    } catch (e) {
      // If localStorage read fails, continue with default
    }
    
    if (!finalTenantId || isNaN(finalTenantId)) {
      finalTenantId = process.env.NODE_ENV === 'production' ? 5 : 3;
    }
  }

  // Save tenantId to localStorage
  try {
    localStorage.setItem('tenantId', finalTenantId.toString());
  } catch (e) {
    // If localStorage write fails, continue without saving
  }

  const loginModel = {
    userNameOrEmailAddress: usernameOrEmail,
    password,
    rememberMe,
    tenantId: finalTenantId,
  };

  return httpClient.post(url, loginModel).then(result => result.data.result.accessToken);
};

const GetCurrentLoginInformation = () => {
  const url = apiConstants.GetCurrentLoginInformation;

  return httpClient.get(url).then(result => result.data.result);
};

export { Authenticate, GetCurrentLoginInformation };
